'use client';

import { useEffect, useState } from 'react';
import Link from 'next/link';
import { applyConsent, getStoredConsent } from '@/lib/ga';
import styles from './ConsentBanner.module.scss';

export default function ConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (getStoredConsent() === null) setVisible(true);
  }, []);

  const choose = (granted: boolean) => {
    applyConsent(granted ? 'granted' : 'denied');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className={styles.banner} role="dialog" aria-live="polite" aria-label="Samtykke til cookies">
      <div className={styles.inner}>
        <div className={styles.text}>
          <p className={styles.title}>Vi bruger cookies</p>
          <p className={styles.body}>
            Vi bruger cookies til statistik og til at vise dig relevante annoncer.
            Du kan acceptere alle cookies eller kun beholde de nødvendige. Læs mere
            i vores{' '}
            <Link href="/handelsbetingelser" className={styles.link}>
              handelsbetingelser
            </Link>
            .
          </p>
        </div>
        <div className={styles.actions}>
          <button
            type="button"
            className={styles.reject}
            onClick={() => choose(false)}
          >
            Kun nødvendige
          </button>
          <button
            type="button"
            className={styles.accept}
            onClick={() => choose(true)}
          >
            Accepter alle
          </button>
        </div>
      </div>
    </div>
  );
}
